// extracted by mini-css-extract-plugin
module.exports = {"pafiyep":"pafiyep","phone":"phone","hidden-phone":"hidden-phone","visible-phone":"visible-phone"};